export const MAP_STYLES = [
  {
    elementType: 'geometry',
    stylers: [
      {
        color: '#202123',
      },
    ],
  },
  {
    elementType: 'geometry.stroke',
    stylers: [
      {
        color: '#38414e',
      },
      {
        visibility: 'on',
      },
    ],
  },
  {
    elementType: 'labels.text.stroke',
    stylers: [
      {
        color: '#fafafa',
      },
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'administrative.country',
    elementType: 'geometry.stroke',
    stylers: [
      {
        lightness: 5,
      },
    ],
  },
  {
    featureType: 'administrative.locality',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#ffffff',
      },
    ],
  },
  {
    featureType: 'poi',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#d59563',
      },
    ],
  },
  {
    featureType: 'poi.business',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'poi.medical',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'poi.park',
    elementType: 'geometry',
    stylers: [
      {
        color: '#263c3f',
      },
    ],
  },
  {
    featureType: 'poi.park',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#6b9a76',
      },
    ],
  },
  {
    featureType: 'poi.school',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'poi.sports_complex',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'road',
    stylers: [
      {
        visibility: 'simplified',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'geometry',
    stylers: [
      {
        color: '#38414e',
      },
      {
        visibility: 'simplified',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#363c4d',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#9ca5b3',
      },
    ],
  },
  {
    featureType: 'transit',
    elementType: 'geometry',
    stylers: [
      {
        color: '#2f3948',
      },
    ],
  },
  {
    featureType: 'transit.station',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#d59563',
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [
      {
        color: '#17263c',
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#515c6d',
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'labels.text.stroke',
    stylers: [
      {
        color: '#17263c',
      },
    ],
  },
];

const initialCoordinates = {
  lat: 53.546066,
  lng: 10.018554,
};

const MAP_OPTIONS = {
  zoom: 14,
  maxZoom: 18,
  minZoom: 2,
  zoomControl: false,
  disableDefaultUI: true,
  scrollwheel: false,
  restriction: {
    latLngBounds: {
      north: 85.0,
      south: -85.0,
      west: -179.0,
      east: 179.0,
    },
    strictBounds: true,
  },
  styles: MAP_STYLES,
};

export const MAP_SETTINGS = {
  center: initialCoordinates,
  options: MAP_OPTIONS,
};

export const MARKER_SETTINGS = {
  position: initialCoordinates,
  icon: 'https://static.andersenlab.com/andersenlab/new-andersensite/landings_NX/forum-bishkek/location/marker-for-map.svg',
  title: 'AI & China: What Europe Should Learn',
  address:
    'Learn how to create successful collaborations between the DACH region and China through cultural understanding, innovation, and mutual cooperation.',
  link: 'https://maps.app.goo.gl/rJnVDWCSKyvyWULs6',
};
